var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.49,
    height: 42.429,
    viewBox: "0 0 45.49 42.429",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{stroke:#000;stroke-width:.4px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box",
    transform: "translate(-8.8 -25.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    d: "M51.344 43.74h-2.273a2.239 2.239 0 0 0-2.138-1.64h-2.427v-5.938a.626.626 0 0 0-.305-.553l-17.121-9.89a.632.632 0 0 0-.635 0L9.318 35.608a.637.637 0 0 0-.318.554V55.94a.639.639 0 0 0 .319.553l17.128 9.889a.639.639 0 0 0 .319.086.672.672 0 0 0 .329-.086l9.013-5.2v3.758a2.706 2.706 0 0 0 2.728 2.713h12.508a2.721 2.721 0 0 0 2.746-2.713V46.495a2.757 2.757 0 0 0-2.746-2.755zm-4.388-.365a.927.927 0 0 1 .927.927v.062a.927.927 0 0 1-.927.927h-3.713a.927.927 0 0 1-.927-.927V44.3a.927.927 0 0 1 .927-.927zM26.767 27.011l7.117 4.109-15.849 9.15-7.117-4.109zm-.607 37.711l-15.882-9.151v-18.3l15.882 9.147zm.607-19.411l-7.454-4.3 15.849-9.151 7.455 4.3zm9.342 1.183v13.214l-8.671 5.014v-18.3l15.791-9.151V42.1h.02a2.239 2.239 0 0 0-2.137 1.643h-2.275a2.742 2.742 0 0 0-2.728 2.752zm16.7 18.447a1.442 1.442 0 0 1-1.468 1.435H38.837a1.426 1.426 0 0 1-1.45-1.435V46.495a1.462 1.462 0 0 1 1.45-1.477h2.3a2.185 2.185 0 0 0 2.112 1.552h3.685a2.185 2.185 0 0 0 2.112-1.552h2.3a1.477 1.477 0 0 1 1.468 1.477z",
    className: "cls-1",
    "data-name": "Path 15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    d: "M337.634 282.29h.669a.639.639 0 0 0 0-1.278h-.025v-1.734h1.762a.615.615 0 0 0 .607.431.641.641 0 0 0 .642-.637v-.43a.647.647 0 0 0-.646-.642h-3.01a.638.638 0 0 0-.634.642v3.01a.634.634 0 0 0 .634.638z",
    className: "cls-1",
    "data-name": "Path 16",
    transform: "translate(-298.061 -229.331)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    d: "M337.639 346.29h3.012a.639.639 0 0 0 .639-.639v-3.012a.639.639 0 0 0-.639-.639h-3.012a.639.639 0 0 0-.639.639v3.012a.639.639 0 0 0 .639.639zm.639-3.012h1.734v1.734h-1.734z",
    className: "cls-1",
    "data-name": "Path 17",
    transform: "translate(-298.061 -287.49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M338.3 409.012h-.025v-1.734h1.728a.642.642 0 1 0 1.285 0v-.616a.666.666 0 0 0-.646-.663h-3.01a.656.656 0 0 0-.634.663v3.01a.616.616 0 0 0 .634.617h.669a.639.639 0 0 0 0-1.278z",
    className: "cls-1",
    "data-name": "Path 18",
    transform: "translate(-298.061 -345.648)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    d: "M357.886 284.726l-1.871 1.871-.569-.569a.639.639 0 0 0-.9.9l1.021 1.021a.639.639 0 0 0 .9 0l2.323-2.323a.639.639 0 0 0-.9-.9z",
    className: "cls-1",
    "data-name": "Path 19",
    transform: "translate(-313.832 -235.273)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M357.886 413.975l-1.871 1.871-.569-.569a.639.639 0 1 0-.9.9l1.021 1.021a.639.639 0 0 0 .9 0l2.323-2.323a.639.639 0 0 0-.9-.9z",
    className: "cls-1",
    "data-name": "Path 20",
    transform: "translate(-313.832 -352.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    d: "M418.543 295h-4.013a.639.639 0 1 0 0 1.278h4.013a.639.639 0 0 0 0-1.278z",
    className: "cls-1",
    "data-name": "Path 21",
    transform: "translate(-367.934 -244.779)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    d: "M418.543 359h-4.013a.639.639 0 1 0 0 1.278h4.013a.639.639 0 0 0 0-1.278z",
    className: "cls-1",
    "data-name": "Path 22",
    transform: "translate(-367.934 -302.938)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    d: "M418.543 423h-4.013a.639.639 0 1 0 0 1.278h4.013a.639.639 0 0 0 0-1.278z",
    className: "cls-1",
    "data-name": "Path 23",
    transform: "translate(-367.934 -361.096)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductStock);
export default __webpack_public_path__ + "static/media/product-stock.6f7d64be.svg";
export { ForwardRef as ReactComponent };